import React, { useState, useEffect } from 'react';
import ReportList from './ReportList';
import ConfigurationHealthCheck from './components/ConfigurationHealthCheck';

const API_BASE_URL = window.location.hostname === 'localhost' 
  ? 'http://localhost:7071' 
  : '';

function StandardsDashboard({ user }) {
    const [standards, setStandards] = useState([]);
    const [isLoadingStandards, setIsLoadingStandards] = useState(true);
    const [error, setError] = useState(null);
    const [runningAudit, setRunningAudit] = useState(null);
    const [auditCount, setAuditCount] = useState(0); 

    useEffect(() => {
        const fetchStandards = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/standards`);
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                const data = await response.json();
                setStandards(data.standards || []);
            } catch (e) {
                setError(e.message);
                console.error("Failed to fetch standards:", e);
            } finally {
                setIsLoadingStandards(false);
            }
        };
        fetchStandards();
    }, []);

    const handleRunAudit = async (standard) => {
        console.log(`Starting audit for standard: ${standard}`);
        setRunningAudit(standard);
        setError(null);

        try {
            const apiUrl = `${API_BASE_URL}/api/compliance/${standard}`;
            
            // We use fetch to check for errors before downloading
            const response = await fetch(apiUrl);

            if (!response.ok) {
                // This is the new security check. It will catch the "403 Forbidden" error.
                const errorText = await response.text();
                throw new Error(errorText || `Failed to run audit: ${response.statusText}`);
            }
            
            // If the response is OK (200), it means the user is subscribed and the
            // report is ready. Now we trigger the browser's download.
            const link = document.createElement('a');
            link.href = apiUrl; // The same URL will now just download the file
            link.setAttribute('download', `Compliance_Report_${standard}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            
            // Refresh the report list in the background
            setAuditCount(prevCount => prevCount + 1);

        } catch (e) {
            setError(e.message);
            console.error("Audit run failed:", e);
        } finally {
            setRunningAudit(null);
        }
    };
    
    const renderStandardsList = () => {
        if (isLoadingStandards) return <p>Loading available standards...</p>;
        
        return (
            <ul>
                {standards.map(standard => (
                    <li key={standard}>
                        <span>{standard}</span>
                        <button onClick={() => handleRunAudit(standard)} disabled={runningAudit !== null}>
                            {runningAudit === standard ? 'Generating Report...' : 'Run Audit & Download Report'}
                        </button>
                    </li>
                ))}
            </ul>
        );
    };

    return (
        <div>
            <ConfigurationHealthCheck />
            <hr />
            
            <h2>Run a New Audit</h2>
            {error && <p className="error">Error: {error}</p>}
            {renderStandardsList()}
            <hr />
            <ReportList key={auditCount} />
        </div>
    );
}

export default StandardsDashboard;